// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-play-pause-button {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 47.4%;
  left: 48.5%;
  background: transparent;
  z-index: 1;
  padding: 0px;
}

.video-container {
  position: relative;
}

.vjs-http-source-selector {
  display: block !important;
}


.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  pointer-events: none;
  /* Allows interactions with the video element */
}

.purchaseShow {
  position: absolute;
}

.livepurchase {
  height: 260px !important;
}

.midHeadingText {
  font-size: 28px;
  font-weight: 500;
  text-transform: capitalize;
}

.midHeadingMessage {
  font-size: 22px;
  font-weight: 200;
}

.midHeadingbtn {
  font-size: 16px;
  font-weight: 400;
}

.my-video-dimensions.vjs_video_3-dimensions.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 0;
}

.my-video-dimensions.vjs-theme-city {
  --vjs-theme-city--primary: #00b3ff;
  --vjs-theme-city--secondary: #fff;
  width: 100% !important;
  overflow: hidden;
}

.my-video-dimensions.vjs-theme-city .vjs-big-play-button {
  width: 60px;
  height: 60px;
  background: none;
  line-height: 60px;
  font-size: 45px;
  border: none;
  top: 50%;
  left: 50%;
  margin-left: -35px;
  color: #ffffff;
  border-radius: 40px;
  transition: 3s;
  align-items: center;
}

.my-video-dimensions.vjs-theme-city.vjs-big-play-button:focus,
.vjs-theme-city:hover .vjs-big-play-button {
  background-color: #0000009c;
  color: #fff;
}

.my-video-dimensions.vjs-fluid {
  padding-top: 0 !important;
  height: 26vh !important;
}

.my-video-dimensions.video-js button {
  background: transparent !important;
}

.my-video-dimensions.video-js .vjs-tech {
  object-fit: contain;
}

.my-video-dimensions.video-js.vjs-playing .vjs-tech {
  pointer-events: all;
}

.vjs-has-started .vjs-big-play-button {
  pointer-events: none;
}

.vjs-paused .vjs-big-play-button {
  pointer-events: all;
}

.my-video-dimensions.vjs-theme-city .vjs-control-bar {
  height: 64px;
}

.my-video-dimensions.video-js .vjs-control-bar {
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
  background: var(--plyr-video-controls-background,
      linear-gradient(transparent, rgba(0, 0, 0, 0.75)));
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  z-index: 3;
}

.my-video-dimensions.vjs-theme-city.vjs-play-control.vjs-icon-placeholder:before {
  border-radius: 4px;
  border: 0px solid #fff0;
  font-size: 30px;
}

.my-video-dimensions.vjs-theme-city .vjs-play-control .vjs-icon-placeholder.vjs-svg-icon {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  fill: currentColor;
  height: 3.8em;
  width: 3.8em;
}

.my-video-dimensions.vjs-button>.vjs-icon-placeholder:before {
  font-size: 3em;
}

.my-video-dimensions.vjs-theme-city .vjs-play-control:hover .vjs-icon-placeholder:before {
  border: 0px solid var(--vjs-theme-fantasy--secondary);
  background: var(--vjs-theme-fantasy--primary);
}

.my-video-dimensions.vjs-theme-city .vjs-volume-panel {
  order: 1;
}

.my-video-dimensions.video-js .vjs-volume-bar {
  margin: 0;
}

.my-video-dimensions.vjs-volume-bar.vjs-slider-horizontal {
  width: 5em;
  height: 0.5em;
}

.my-video-dimensions.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal,
.my-video-dimensions.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,
.my-video-dimensions.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-horizontal,
.my-video-dimensions.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal,
.my-video-dimensions.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,
.my-video-dimensions.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal {
  width: 5em;
  height: 2em;
  margin-top: 1.25em;
  top: 1.25em;
}

.my-video-dimensions.vjs-theme-city .vjs-progress-control {
  font-size: 12px;
}

.my-video-dimensions.video-js .vjs-slider {
  border-radius: 3px;
}

.my-video-dimensions.vjs-slider-horizontal .vjs-volume-level {
  height: 0.5em;
}

.my-video-dimensions.video-js .vjs-volume-level:before {
  font-size: 1.4em;
}

.my-video-dimensions.video-js .vjs-progress-holder .vjs-load-progress,
.my-video-dimensions.video-js .vjs-progress-holder .vjs-load-progress div,
.my-video-dimensions.video-js .vjs-progress-holder .vjs-play-progress {
  border-radius: 3px;
}

.my-video-dimensions.vjs-theme-city .vjs-play-progress:before {
  border-radius: 0.8em;
}

.my-video-dimensions.vjs-theme-city .vjs-play-progress:before {
  background-color: white;
}

.my-video-dimensions.video-js .vjs-progress-holder {
  flex: auto;
  transition: all 0.2s;
  height: 0.2em;
}

.my-video-dimensions.video-js .vjs-time-tooltip {
  border-radius: 1.3em;
  top: -3.8em;
}

.my-video-dimensions.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip,
.my-video-dimensions.video-js .vjs-progress-control:hover .vjs-time-tooltip {
  font-size: 0.8em;
}

.my-video-dimensions.vjs-menu li {
  padding: 0.5em 0;
  line-height: 1.5em;
  font-size: 1.5em;
}

.my-video-dimensions.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  background-color: #2b333f;
  background-color: rgb(0 0 0 / 70%);
  position: absolute;
  width: 100%;
  bottom: 3.5em;
  max-height: 25em;
  border-radius: 5px;
}

.vjs-icon-picture-in-picture-enter:before,
.my-video-dimensions.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before {
  line-height: 62.57px;
}

.vjs-icon-play,
.my-video-dimensions.video-js .vjs-play-control .vjs-icon-placeholder,
.my-video-dimensions.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.my-video-dimensions.video-js .vjs-fullscreen-control .vjs-icon-placeholder,
.my-video-dimensions.video-js .vjs-fullscreen-control .vjs-icon-placeholder,
.vjs-icon-fullscreen-enter {
  font-size: 1.8em;
}

.vjs-icon-fullscreen-enter:before,
.my-video-dimensions .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "\\f108";
  line-height: 2.1em;
}

.vjs-icon-fullscreen-enter:before,
.my-video-dimensions.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "\\f108";
  font-size: 25px;
  margin-top: 8px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.my-video-dimensions.vjs-theme-city .vjs-progress-control .vjs-progress-holder,
.my-video-dimensions.vjs-theme-city .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1.5em;
}

.my-video-dimensions.vjs-play-progress .vjs-svg-icon {
  position: absolute;
  top: -0.7em;
  right: -0.4em;
  width: 1.7em;
  height: 1.5em;
  pointer-events: none;
  line-height: 0.15em;
  z-index: 1;
}

.my-video-dimensions.video-js .vjs-remaining-time {
  display: flex;
  align-items: center;
}


.my-video-dimensions.vjs-paused .vjs-big-play-button {
  opacity: 1;
  pointer-events: auto;
  transition: opacity 0.5s;
}

.my-video-dimensions.vjs-big-play-button .vjs-svg-icon {
  width: 1.2em;
  height: 1.2em;
  position: absolute;
  top: 50%;
  left: 50%;
  line-height: 0;
  transform: translate(-50%, -50%);
}

.my-video-dimensions.vjs-theme-city .vjs-fullscreen-control {
  order: 3;
}

.fds {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: x-large;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.my-video-dimensions.video-js .vjs-mute-control .vjs-icon-placeholder.vjs-svg-icon {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  fill: currentColor;
  height: 2.8em;
  width: 2.8em;
}

.my-video-dimensions.vjs-title-bar {
  background: none;
  cursor: pointer;
  display: block !important;
  padding-top: 0.666em;
  padding-left: 51px;
  font-size: 24px;
  font-family: "Poppins";
  font-weight: 200;
}

.my-video-dimensions.vjs-play-progress .vjs-svg-icon {
  position: absolute;
  top: -0.35em;
  right: -0.4em;
  width: 0.9em;
  height: 0.9em;
  pointer-events: none;
  line-height: 0.1em;
  z-index: 1;
}

.my-button {
  display: block;
}

.my-video-dimensions.video-js .vjs-modal-dialog {
  background: #454545;
  overflow: visible;
  box-shadow: 5px 5px 10px gray;
  border-radius: 2px;
}

.vjs-modal-dialog .vjs-modal-dialog-content {
  padding: 20px 24px;
  z-index: 1;
  display: flex;
  /* position: fixed; */
}

.my-video-dimensions.video-js.vjs-quality-selector {
  display: block;
}

.my-video-dimensions.video-js.vjs-http-source-selector {
  display: block;
}

.my-video-dimensions.vjs-icon-cog:before {
  content: "\\f114";
  font-size: x-large;
}

.backbutton {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 0;
  background: transparent;
  z-index: 1;
}

.custom-play-pause-button {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 47.4%;
  left: 48.5%;
  background: transparent;
  z-index: 1;
  padding: 0px;
}

.custom-skip-forward-button {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 47.4%;
  left: 65%;
  background: transparent;
  z-index: 1;
}

.custom-skip-backward-button {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 47.4%;
  left: 30%;
  background: transparent;
  z-index: 1;
}

.custom-reload-button {
  position: absolute;
  z-index: 1;
}

.custom-fullscreen-button {
  position: absolute;
  pointer-events: auto;
  z-index: 1;
  top: 0;
  right: 0;
  padding-top: 2em;
  padding-right: 2em;
}

.titlebutton {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 0;
  background: transparent;
  z-index: 1;
  background: none;
  cursor: pointer;
  display: block !important;
  padding-top: 0.666em;
  padding-left: 51px;
  font-size: 24px;
  font-family: "Poppins";
  font-weight: 200;
}

.my-video-dimensions.video-js .vjs-control.kk {
  position: relative;
  text-align: center;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 1.2em;
  flex: none;
  background: none;
  line-height: 60px;
  font-size: 25px;
  border: none;
  top: -9px;
  left: 227%;
  margin-top: -35px;
  margin-left: -35px;
  color: #ffffff;
}

.ad-information-card {
  position: absolute;
  top: 70px;
  right: 30px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  z-index: 100;
}

.skipRecapWrapper {
  bottom: 70px;
  right: 50px;
}

.skipText {
  font-size: 15px;
}

.endCard {
  position: relative;
  z-index: 1;
}

.endCardBanner {
  width: 100%;
  height: 160px;
  overflow: hidden;
}

.endCardImage {
  animation: zoomIn 0.5s linear;
}

@keyframes zoomIn {
  0% {
    transform: scale(0.5);
  }

  100% {
    transform: scale(1);
  }
}

/* .my-video-dimensions.video-js .vjs-control.kkk {
    position: relative;
    text-align: center;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 1.2em;
    flex: none;
    background: none;
    line-height: 60px;
    font-size: 25px;
    border: none;
    top: -9px;
    left: -190%;
    color: #ffffff;
  } */

.my-video-dimensions.video-js:hover .vjs-big-play-button {
  border-color: #fff;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
  transition: all 0s;
}

.my-video-dimensions.video-js.vjs-user-active.vjs-big-play-button {
  display: block !important;
  visibility: visible;
  opacity: 0;
  transition: visibility 1s, opacity 1s;
}

.my-video-dimensions.vjs-controls-disabled .vjs-big-play-button .vjs-icon-placeholder,
.my-video-dimensions.vjs-has-started .vjs-big-play-button .vjs-icon-placeholder,
.my-video-dimensions.vjs-using-native-controls .vjs-big-play-button .vjs-icon-placeholder {
  content: "\\f103";
}

.my-video-dimensions.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {
  content: "\\f103" !important;
}

.my-video-dimensions.vjs-paused .vjs-big-play-button {
  display: block !important;
}

.my-video-dimensions.video-js:hover .vjs-big-play-button,
.my-video-dimensions.video-js .vjs-big-play-button:focus {
  border-color: #fff;
  background-color: transparent;
}

/* .my-video-dimensions .vjs-audio-button {
    display: none !important;
  } */
.my-video-dimensions .vjs-subtitles-button {
  display: block !important;
}

.vjs-captions-button {
  display: block !important;
}

.my-video-dimensions.vjs-button:focus-visible {
  outline: transparent;
}

.my-video-dimensions.video-js .vjs-volume-panel .vjs-volume-control {
  visibility: visible;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin-left: 9px;
}

.my-video-dimensions.video-js.vjs-volume-level {
  background-color: #095ae5;
}

.my-video-dimensions.video-js.vjs-playing .vjs-big-play-button .vjs-icon-placeholder:before {
  content: "\\f103";
}

.vjs-icon-play,
.my-video-dimensions .video-js .vjs-play-control .vjs-icon-placeholder,
.my-video-dimensions.video-js .vjs-big-play-button .vjs-icon-placeholder::before {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
  font-size: 36px;
}

.my-video-dimensions.video-js .vjs-big-play-button {
  font-size: 3em;
  line-height: 1.5em;
  height: 1.63332em;
  width: 3em;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 0;
  margin-top: -0.81666em;
  margin-left: -1.5em;
  cursor: pointer;
  opacity: 1;
  border: none;
  background-color: transparent;
  border-radius: none;
  transition: all 0.4s;
}

.my-video-dimensions.video-js:hover .vjs-big-play-button,
.my-video-dimensions.video-js .vjs-big-play-button:focus {
  border-color: #fff;
  background-color: transparent;
  transition: all 0s;
}

.vjs-icon-play:before,
.my-video-dimensions .video-js .vjs-play-control .vjs-icon-placeholder:before,
.my-video-dimensions.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  content: "\\f101";
}

.vjs-loading-spinner-myvideo {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.85;
  text-align: left;
  border: 0.3em solid #095ae5;
  box-sizing: border-box;
  background-clip: padding-box;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  visibility: hidden;
}

.vjs-seeking .vjs-loading-spinner-myvideo,
.vjs-waiting .vjs-loading-spinner-myvideo {
  display: block;
  animation: vjs-spinner-showw 0s linear 0.3s forwards;
}

.vjs-error .vjs-loading-spinner-myvideo {
  display: none;
}

.vjs-loading-spinner-myvideo:before,
.vjs-loading-spinner-myvideo:after {
  content: "";
  position: absolute;
  margin: -0.3em;
  box-sizing: inherit;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  opacity: 1;
  border: inherit;
  border-color: transparent;
  border-top-color: #095ae5;
}

.vjs-seeking .vjs-loading-spinner-myvideo:before,
.vjs-seeking .vjs-loading-spinner-myvideo:after,
.vjs-waiting .vjs-loading-spinner-myvideo:before,
.vjs-waiting .vjs-loading-spinner-myvideo:after {
  animation: vjs-spinner-spinn 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
    vjs-spinner-fadee 1.1s linear infinite;
}

.vjs-seeking .vjs-loading-spinner-myvideo:before,
.vjs-waiting .vjs-loading-spinner-myvideo:before {
  border-top-color: deepskyblue;
}

.vjs-seeking .vjs-loading-spinner-myvideo:after,
.vjs-waiting .vjs-loading-spinner-myvideo:after {
  border-top-color: deepskyblue;
  animation-delay: 0.44s;
}

@keyframes vjs-spinner-showw {
  to {
    visibility: visible;
  }
}

@keyframes vjs-spinner-spinn {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes vjs-spinner-fadee {
  0% {
    border-top-color: #095ae5;
  }

  20% {
    border-top-color: #095ae5;
  }

  35% {
    border-top-color: deepskyblue;
  }

  60% {
    border-top-color: #095ae5;
  }

  100% {
    border-top-color: #095ae5;
  }
}

.my-video-dimensions.vjs-live .vjs-progress-control {
  display: flex;
}

.my-video-dimensions.video-js .vjs-live-control {
  display: contents;
  align-items: center;
  line-height: 3em;
  padding: 10px;
  font-family: "Poppins";
  font-weight: 600;
  font-size: 18px;
}

.vjs-menu-button-popup .vjs-menu {
  display: none;
  position: absolute;
  bottom: 0;
  width: 10em;
  left: -3em;
  height: 0em;
  margin-bottom: 3.5em;
  border-top-color: rgba(43, 51, 63, 0.7);
}

.vjs-menu-button-popup .vjs-menu::after {
  content: "";
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 8px;
  border-style: solid;
  border-color: #2b333f transparent transparent transparent;
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  position: absolute;
  max-height: 15em;
  background-color: #2b333f;
  border-radius: 5px;
  bottom: 0 !important;
  width: 50% !important;
  z-index: 2 !important;
  font-size: 8px !important;
  right: 35px !important;
}

.vjs-menu li {
  list-style: none;
  margin: 0;
  padding: 0.6em 0;
  line-height: 1.4em;
  font-size: 1.4em;
  text-align: center;
  text-transform: capitalize;
}

.vjs-menu li.vjs-selected,
.vjs-menu li.vjs-selected:focus,
.vjs-menu li.vjs-selected:hover,
.js-focus-visible .vjs-menu li.vjs-selected:hover {
  color: white;
  background-color: #095ae5;
}

.vjs-menu li.vjs-menu-item:focus,
.vjs-menu li.vjs-menu-item:hover,
.js-focus-visible .vjs-menu li.vjs-menu-item:hover {
  background-color: #095ae5;
}

.my-video-dimensions.video-js .vjs-play-progress:before {
  font-size: 0.8em;
  position: absolute;
  right: -0.5em;
  z-index: 1;
  text-align: center;
  color: white;
  background-color: white;
}

.my-video-dimensions.video-js .vjs-slider {
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0 0.45em 0 0.45em;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  background-color: #73859f;
}

.my-video-dimensions.video-js .vjs-load-progress div {
  background: #73859f;
}

.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control,
.video-js .vjs-volume-panel:active .vjs-volume-control,
.video-js .vjs-volume-panel:focus .vjs-volume-control,
.video-js .vjs-volume-panel .vjs-volume-control:active,
.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control,
.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active {
  visibility: visible;
  opacity: 1;
  position: relative;
  transition: none;
}

.vjs-volume-bar.vjs-slider-vertical {
  width: 0.3em;
  height: 8em;
  margin: 1.35em auto;
}

@media only screen and (max-width: 600px) {
  .my-video-dimensions.video-js .vjs-tech {
    object-fit: contain;
  }
}

@keyframes backgroundSlide {
  0% {
    background-position: 100% 0%;
  }

  100% {
    background-position: 0% 0%;
  }
}

.next-videos-slider {
  display: flex;
  overflow: hidden;
  padding: 20px;
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 68.4%;
  /* left: ; */
  background: transparent;
  z-index: 1;
}

.video-thumbnail {
  width: 212px;
  height: 119px;
  object-fit: cover;
  pointer-events: auto;
  background: transparent;
  z-index: 1;
  border-radius: 8px;
}

.video-title {
  text-align: center;
  font-size: 14px;
  margin-top: 5px;
}

.tog {
  pointer-events: auto;
  position: absolute;
  color: white;
  top: 80.4%;
  left: 48.6%;
  background: transparent;
  z-index: 1;
}

/* Theme-Video-Player */
.theme-video-dimensions.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 46.25%;
}

.theme-video-dimensions.video-js .vjs-tech {
  object-fit: cover;
}

.swiper-wrapper-container {
  position: relative;
  width: 100%;
  top: 57%;
}

.playerClose {
  font-size: 25px !important;
  color: white;
  position: absolute;
  z-index: 1;
}

.close-button {
  position: absolute;
  top: -38px;
  right: 21px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 16px;
  cursor: pointer;
  z-index: 10;
}

.vjs-icon-captions:before,
.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before,
.video-js .vjs-captions-button .vjs-icon-placeholder:before {
  content: "\\f10c";
}

.my-video-dimensions.video-js.vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: middle;
  display: none;
  margin-bottom: -0.1em;
}

.vjs-button>.vjs-icon-placeholder:before {
  font-size: 1.8em;
  /* line-height: 1.67; */
}

.my-video-dimensions.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: middle;
  display: none;
  margin-bottom: -0.1em;
}

.my-video-dimensions .vjs-button>.vjs-icon-placeholder:before {
  position: relative;
  font-size: 25px;
}

.my-video-dimensions .vjs-remaining-time-display {
  font-size: 15px;
}

.my-video-dimensions .vjs-playback-rate .vjs-playback-rate-value {
  top: 17px !important;
}

.play-skip-button-center {
  inset: 0;
  margin: auto auto;
  height: 20px;
  z-index: 1;
  display: flex;
}

.custom-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.vjs-marker {
  position: absolute;
  top: 30px;
  width: 4px;
  height: 0.4em;
  background-color: #fbeb2b;
}

/* #vjs_video_3_ima-countdown-div,  */
.hideTitle {
  display: none !important;
}

.my-video-dimensions.video-js .vjs-progress-holder .vjs-progress-end {
  width: 100% !important;
}

.vjs-live-display-playout {
  font-size: 18px;
}

.vjs-live-display {
  display: none !important;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.live_dot {
  animation: blink 1s infinite;
  font-size: 30px;
  color: red;
}

.watermark-link:hover {
  opacity: 1 !important;
  transition: opacity 0.5s ease-in-out;
}

.vjs-icon-cog:before {
  content: "" !important;
}

.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 19em;
  font-size: 8px;
}

.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 19em;
  font-size: 8px;
}

.vjs-menu-content {
  bottom: 0;
  width: 50%;
  z-index: 2;
  font-size: 8px;
  right: 35px;
}

.vjs-playback-rate .vjs-playback-rate-value {
  font-size: 13px;
  line-height: 3 !important;
}

.my-video-dimensions.video-js .vjs-progress-holder .vjs-play-progress {
  width: 100% !important;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Tv_Playout/PlayoutPlayer.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D;wDACsD;EACtD,gEAAgE;EAChE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;;;;;;EAME,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;;;;;;;;;;;;KAeK;;AAEL;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;KAEK;AACL;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE;0CACwC;AAC1C;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAgCA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB","sourcesContent":[".custom-play-pause-button {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 47.4%;\n  left: 48.5%;\n  background: transparent;\n  z-index: 1;\n  padding: 0px;\n}\n\n.video-container {\n  position: relative;\n}\n\n.vjs-http-source-selector {\n  display: block !important;\n}\n\n\n.video-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  pointer-events: none;\n  /* Allows interactions with the video element */\n}\n\n.purchaseShow {\n  position: absolute;\n}\n\n.livepurchase {\n  height: 260px !important;\n}\n\n.midHeadingText {\n  font-size: 28px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.midHeadingMessage {\n  font-size: 22px;\n  font-weight: 200;\n}\n\n.midHeadingbtn {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.my-video-dimensions.vjs_video_3-dimensions.vjs-fluid:not(.vjs-audio-only-mode) {\n  padding-top: 0;\n}\n\n.my-video-dimensions.vjs-theme-city {\n  --vjs-theme-city--primary: #00b3ff;\n  --vjs-theme-city--secondary: #fff;\n  width: 100% !important;\n  overflow: hidden;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-big-play-button {\n  width: 60px;\n  height: 60px;\n  background: none;\n  line-height: 60px;\n  font-size: 45px;\n  border: none;\n  top: 50%;\n  left: 50%;\n  margin-left: -35px;\n  color: #ffffff;\n  border-radius: 40px;\n  transition: 3s;\n  align-items: center;\n}\n\n.my-video-dimensions.vjs-theme-city.vjs-big-play-button:focus,\n.vjs-theme-city:hover .vjs-big-play-button {\n  background-color: #0000009c;\n  color: #fff;\n}\n\n.my-video-dimensions.vjs-fluid {\n  padding-top: 0 !important;\n  height: 26vh !important;\n}\n\n.my-video-dimensions.video-js button {\n  background: transparent !important;\n}\n\n.my-video-dimensions.video-js .vjs-tech {\n  object-fit: contain;\n}\n\n.my-video-dimensions.video-js.vjs-playing .vjs-tech {\n  pointer-events: all;\n}\n\n.vjs-has-started .vjs-big-play-button {\n  pointer-events: none;\n}\n\n.vjs-paused .vjs-big-play-button {\n  pointer-events: all;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-control-bar {\n  height: 64px;\n}\n\n.my-video-dimensions.video-js .vjs-control-bar {\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));\n  background: var(--plyr-video-controls-background,\n      linear-gradient(transparent, rgba(0, 0, 0, 0.75)));\n  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;\n  z-index: 3;\n}\n\n.my-video-dimensions.vjs-theme-city.vjs-play-control.vjs-icon-placeholder:before {\n  border-radius: 4px;\n  border: 0px solid #fff0;\n  font-size: 30px;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-play-control .vjs-icon-placeholder.vjs-svg-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-position: center;\n  fill: currentColor;\n  height: 3.8em;\n  width: 3.8em;\n}\n\n.my-video-dimensions.vjs-button>.vjs-icon-placeholder:before {\n  font-size: 3em;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-play-control:hover .vjs-icon-placeholder:before {\n  border: 0px solid var(--vjs-theme-fantasy--secondary);\n  background: var(--vjs-theme-fantasy--primary);\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-volume-panel {\n  order: 1;\n}\n\n.my-video-dimensions.video-js .vjs-volume-bar {\n  margin: 0;\n}\n\n.my-video-dimensions.vjs-volume-bar.vjs-slider-horizontal {\n  width: 5em;\n  height: 0.5em;\n}\n\n.my-video-dimensions.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal,\n.my-video-dimensions.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,\n.my-video-dimensions.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-horizontal,\n.my-video-dimensions.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal,\n.my-video-dimensions.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,\n.my-video-dimensions.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal {\n  width: 5em;\n  height: 2em;\n  margin-top: 1.25em;\n  top: 1.25em;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-progress-control {\n  font-size: 12px;\n}\n\n.my-video-dimensions.video-js .vjs-slider {\n  border-radius: 3px;\n}\n\n.my-video-dimensions.vjs-slider-horizontal .vjs-volume-level {\n  height: 0.5em;\n}\n\n.my-video-dimensions.video-js .vjs-volume-level:before {\n  font-size: 1.4em;\n}\n\n.my-video-dimensions.video-js .vjs-progress-holder .vjs-load-progress,\n.my-video-dimensions.video-js .vjs-progress-holder .vjs-load-progress div,\n.my-video-dimensions.video-js .vjs-progress-holder .vjs-play-progress {\n  border-radius: 3px;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-play-progress:before {\n  border-radius: 0.8em;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-play-progress:before {\n  background-color: white;\n}\n\n.my-video-dimensions.video-js .vjs-progress-holder {\n  flex: auto;\n  transition: all 0.2s;\n  height: 0.2em;\n}\n\n.my-video-dimensions.video-js .vjs-time-tooltip {\n  border-radius: 1.3em;\n  top: -3.8em;\n}\n\n.my-video-dimensions.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip,\n.my-video-dimensions.video-js .vjs-progress-control:hover .vjs-time-tooltip {\n  font-size: 0.8em;\n}\n\n.my-video-dimensions.vjs-menu li {\n  padding: 0.5em 0;\n  line-height: 1.5em;\n  font-size: 1.5em;\n}\n\n.my-video-dimensions.vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  background-color: #2b333f;\n  background-color: rgb(0 0 0 / 70%);\n  position: absolute;\n  width: 100%;\n  bottom: 3.5em;\n  max-height: 25em;\n  border-radius: 5px;\n}\n\n.vjs-icon-picture-in-picture-enter:before,\n.my-video-dimensions.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before {\n  line-height: 62.57px;\n}\n\n.vjs-icon-play,\n.my-video-dimensions.video-js .vjs-play-control .vjs-icon-placeholder,\n.my-video-dimensions.video-js .vjs-big-play-button .vjs-icon-placeholder:before {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n}\n\n.my-video-dimensions.video-js .vjs-fullscreen-control .vjs-icon-placeholder,\n.my-video-dimensions.video-js .vjs-fullscreen-control .vjs-icon-placeholder,\n.vjs-icon-fullscreen-enter {\n  font-size: 1.8em;\n}\n\n.vjs-icon-fullscreen-enter:before,\n.my-video-dimensions .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {\n  content: \"\\f108\";\n  line-height: 2.1em;\n}\n\n.vjs-icon-fullscreen-enter:before,\n.my-video-dimensions.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {\n  content: \"\\f108\";\n  font-size: 25px;\n  margin-top: 8px;\n}\n\n.responsive-iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-progress-control .vjs-progress-holder,\n.my-video-dimensions.vjs-theme-city .vjs-progress-control:hover .vjs-progress-holder {\n  font-size: 1.5em;\n}\n\n.my-video-dimensions.vjs-play-progress .vjs-svg-icon {\n  position: absolute;\n  top: -0.7em;\n  right: -0.4em;\n  width: 1.7em;\n  height: 1.5em;\n  pointer-events: none;\n  line-height: 0.15em;\n  z-index: 1;\n}\n\n.my-video-dimensions.video-js .vjs-remaining-time {\n  display: flex;\n  align-items: center;\n}\n\n\n.my-video-dimensions.vjs-paused .vjs-big-play-button {\n  opacity: 1;\n  pointer-events: auto;\n  transition: opacity 0.5s;\n}\n\n.my-video-dimensions.vjs-big-play-button .vjs-svg-icon {\n  width: 1.2em;\n  height: 1.2em;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  line-height: 0;\n  transform: translate(-50%, -50%);\n}\n\n.my-video-dimensions.vjs-theme-city .vjs-fullscreen-control {\n  order: 3;\n}\n\n.fds {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: x-large;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.my-video-dimensions.video-js .vjs-mute-control .vjs-icon-placeholder.vjs-svg-icon {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-position: center;\n  fill: currentColor;\n  height: 2.8em;\n  width: 2.8em;\n}\n\n.my-video-dimensions.vjs-title-bar {\n  background: none;\n  cursor: pointer;\n  display: block !important;\n  padding-top: 0.666em;\n  padding-left: 51px;\n  font-size: 24px;\n  font-family: \"Poppins\";\n  font-weight: 200;\n}\n\n.my-video-dimensions.vjs-play-progress .vjs-svg-icon {\n  position: absolute;\n  top: -0.35em;\n  right: -0.4em;\n  width: 0.9em;\n  height: 0.9em;\n  pointer-events: none;\n  line-height: 0.1em;\n  z-index: 1;\n}\n\n.my-button {\n  display: block;\n}\n\n.my-video-dimensions.video-js .vjs-modal-dialog {\n  background: #454545;\n  overflow: visible;\n  box-shadow: 5px 5px 10px gray;\n  border-radius: 2px;\n}\n\n.vjs-modal-dialog .vjs-modal-dialog-content {\n  padding: 20px 24px;\n  z-index: 1;\n  display: flex;\n  /* position: fixed; */\n}\n\n.my-video-dimensions.video-js.vjs-quality-selector {\n  display: block;\n}\n\n.my-video-dimensions.video-js.vjs-http-source-selector {\n  display: block;\n}\n\n.my-video-dimensions.vjs-icon-cog:before {\n  content: \"\\f114\";\n  font-size: x-large;\n}\n\n.backbutton {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 0;\n  background: transparent;\n  z-index: 1;\n}\n\n.custom-play-pause-button {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 47.4%;\n  left: 48.5%;\n  background: transparent;\n  z-index: 1;\n  padding: 0px;\n}\n\n.custom-skip-forward-button {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 47.4%;\n  left: 65%;\n  background: transparent;\n  z-index: 1;\n}\n\n.custom-skip-backward-button {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 47.4%;\n  left: 30%;\n  background: transparent;\n  z-index: 1;\n}\n\n.custom-reload-button {\n  position: absolute;\n  z-index: 1;\n}\n\n.custom-fullscreen-button {\n  position: absolute;\n  pointer-events: auto;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  padding-top: 2em;\n  padding-right: 2em;\n}\n\n.titlebutton {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 0;\n  background: transparent;\n  z-index: 1;\n  background: none;\n  cursor: pointer;\n  display: block !important;\n  padding-top: 0.666em;\n  padding-left: 51px;\n  font-size: 24px;\n  font-family: \"Poppins\";\n  font-weight: 200;\n}\n\n.my-video-dimensions.video-js .vjs-control.kk {\n  position: relative;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 1.2em;\n  flex: none;\n  background: none;\n  line-height: 60px;\n  font-size: 25px;\n  border: none;\n  top: -9px;\n  left: 227%;\n  margin-top: -35px;\n  margin-left: -35px;\n  color: #ffffff;\n}\n\n.ad-information-card {\n  position: absolute;\n  top: 70px;\n  right: 30px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 10px;\n  border-radius: 5px;\n  z-index: 100;\n}\n\n.skipRecapWrapper {\n  bottom: 70px;\n  right: 50px;\n}\n\n.skipText {\n  font-size: 15px;\n}\n\n.endCard {\n  position: relative;\n  z-index: 1;\n}\n\n.endCardBanner {\n  width: 100%;\n  height: 160px;\n  overflow: hidden;\n}\n\n.endCardImage {\n  animation: zoomIn 0.5s linear;\n}\n\n@keyframes zoomIn {\n  0% {\n    transform: scale(0.5);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* .my-video-dimensions.video-js .vjs-control.kkk {\n    position: relative;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 1.2em;\n    flex: none;\n    background: none;\n    line-height: 60px;\n    font-size: 25px;\n    border: none;\n    top: -9px;\n    left: -190%;\n    color: #ffffff;\n  } */\n\n.my-video-dimensions.video-js:hover .vjs-big-play-button {\n  border-color: #fff;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n  transition: all 0s;\n}\n\n.my-video-dimensions.video-js.vjs-user-active.vjs-big-play-button {\n  display: block !important;\n  visibility: visible;\n  opacity: 0;\n  transition: visibility 1s, opacity 1s;\n}\n\n.my-video-dimensions.vjs-controls-disabled .vjs-big-play-button .vjs-icon-placeholder,\n.my-video-dimensions.vjs-has-started .vjs-big-play-button .vjs-icon-placeholder,\n.my-video-dimensions.vjs-using-native-controls .vjs-big-play-button .vjs-icon-placeholder {\n  content: \"\\f103\";\n}\n\n.my-video-dimensions.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {\n  content: \"\\f103\" !important;\n}\n\n.my-video-dimensions.vjs-paused .vjs-big-play-button {\n  display: block !important;\n}\n\n.my-video-dimensions.video-js:hover .vjs-big-play-button,\n.my-video-dimensions.video-js .vjs-big-play-button:focus {\n  border-color: #fff;\n  background-color: transparent;\n}\n\n/* .my-video-dimensions .vjs-audio-button {\n    display: none !important;\n  } */\n.my-video-dimensions .vjs-subtitles-button {\n  display: block !important;\n}\n\n.vjs-captions-button {\n  display: block !important;\n}\n\n.my-video-dimensions.vjs-button:focus-visible {\n  outline: transparent;\n}\n\n.my-video-dimensions.video-js .vjs-volume-panel .vjs-volume-control {\n  visibility: visible;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n  margin-left: 9px;\n}\n\n.my-video-dimensions.video-js.vjs-volume-level {\n  background-color: #095ae5;\n}\n\n.my-video-dimensions.video-js.vjs-playing .vjs-big-play-button .vjs-icon-placeholder:before {\n  content: \"\\f103\";\n}\n\n.vjs-icon-play,\n.my-video-dimensions .video-js .vjs-play-control .vjs-icon-placeholder,\n.my-video-dimensions.video-js .vjs-big-play-button .vjs-icon-placeholder::before {\n  font-family: VideoJS;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 36px;\n}\n\n.my-video-dimensions.video-js .vjs-big-play-button {\n  font-size: 3em;\n  line-height: 1.5em;\n  height: 1.63332em;\n  width: 3em;\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  padding: 0;\n  margin-top: -0.81666em;\n  margin-left: -1.5em;\n  cursor: pointer;\n  opacity: 1;\n  border: none;\n  background-color: transparent;\n  border-radius: none;\n  transition: all 0.4s;\n}\n\n.my-video-dimensions.video-js:hover .vjs-big-play-button,\n.my-video-dimensions.video-js .vjs-big-play-button:focus {\n  border-color: #fff;\n  background-color: transparent;\n  transition: all 0s;\n}\n\n.vjs-icon-play:before,\n.my-video-dimensions .video-js .vjs-play-control .vjs-icon-placeholder:before,\n.my-video-dimensions.video-js .vjs-big-play-button .vjs-icon-placeholder:before {\n  content: \"\\f101\";\n}\n\n.vjs-loading-spinner-myvideo {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0.85;\n  text-align: left;\n  border: 0.3em solid #095ae5;\n  box-sizing: border-box;\n  background-clip: padding-box;\n  width: 5em;\n  height: 5em;\n  border-radius: 50%;\n  visibility: hidden;\n}\n\n.vjs-seeking .vjs-loading-spinner-myvideo,\n.vjs-waiting .vjs-loading-spinner-myvideo {\n  display: block;\n  animation: vjs-spinner-showw 0s linear 0.3s forwards;\n}\n\n.vjs-error .vjs-loading-spinner-myvideo {\n  display: none;\n}\n\n.vjs-loading-spinner-myvideo:before,\n.vjs-loading-spinner-myvideo:after {\n  content: \"\";\n  position: absolute;\n  margin: -0.3em;\n  box-sizing: inherit;\n  width: inherit;\n  height: inherit;\n  border-radius: inherit;\n  opacity: 1;\n  border: inherit;\n  border-color: transparent;\n  border-top-color: #095ae5;\n}\n\n.vjs-seeking .vjs-loading-spinner-myvideo:before,\n.vjs-seeking .vjs-loading-spinner-myvideo:after,\n.vjs-waiting .vjs-loading-spinner-myvideo:before,\n.vjs-waiting .vjs-loading-spinner-myvideo:after {\n  animation: vjs-spinner-spinn 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,\n    vjs-spinner-fadee 1.1s linear infinite;\n}\n\n.vjs-seeking .vjs-loading-spinner-myvideo:before,\n.vjs-waiting .vjs-loading-spinner-myvideo:before {\n  border-top-color: deepskyblue;\n}\n\n.vjs-seeking .vjs-loading-spinner-myvideo:after,\n.vjs-waiting .vjs-loading-spinner-myvideo:after {\n  border-top-color: deepskyblue;\n  animation-delay: 0.44s;\n}\n\n@keyframes vjs-spinner-showw {\n  to {\n    visibility: visible;\n  }\n}\n\n@keyframes vjs-spinner-spinn {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes vjs-spinner-fadee {\n  0% {\n    border-top-color: #095ae5;\n  }\n\n  20% {\n    border-top-color: #095ae5;\n  }\n\n  35% {\n    border-top-color: deepskyblue;\n  }\n\n  60% {\n    border-top-color: #095ae5;\n  }\n\n  100% {\n    border-top-color: #095ae5;\n  }\n}\n\n.my-video-dimensions.vjs-live .vjs-progress-control {\n  display: flex;\n}\n\n.my-video-dimensions.video-js .vjs-live-control {\n  display: contents;\n  align-items: center;\n  line-height: 3em;\n  padding: 10px;\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.vjs-menu-button-popup .vjs-menu {\n  display: none;\n  position: absolute;\n  bottom: 0;\n  width: 10em;\n  left: -3em;\n  height: 0em;\n  margin-bottom: 3.5em;\n  border-top-color: rgba(43, 51, 63, 0.7);\n}\n\n.vjs-menu-button-popup .vjs-menu::after {\n  content: \"\";\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: #2b333f transparent transparent transparent;\n}\n\n.vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  position: absolute;\n  max-height: 15em;\n  background-color: #2b333f;\n  border-radius: 5px;\n  bottom: 0 !important;\n  width: 50% !important;\n  z-index: 2 !important;\n  font-size: 8px !important;\n  right: 35px !important;\n}\n\n.vjs-menu li {\n  list-style: none;\n  margin: 0;\n  padding: 0.6em 0;\n  line-height: 1.4em;\n  font-size: 1.4em;\n  text-align: center;\n  text-transform: capitalize;\n}\n\n.vjs-menu li.vjs-selected,\n.vjs-menu li.vjs-selected:focus,\n.vjs-menu li.vjs-selected:hover,\n.js-focus-visible .vjs-menu li.vjs-selected:hover {\n  color: white;\n  background-color: #095ae5;\n}\n\n.vjs-menu li.vjs-menu-item:focus,\n.vjs-menu li.vjs-menu-item:hover,\n.js-focus-visible .vjs-menu li.vjs-menu-item:hover {\n  background-color: #095ae5;\n}\n\n.my-video-dimensions.video-js .vjs-play-progress:before {\n  font-size: 0.8em;\n  position: absolute;\n  right: -0.5em;\n  z-index: 1;\n  text-align: center;\n  color: white;\n  background-color: white;\n}\n\n.my-video-dimensions.video-js .vjs-slider {\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 0.45em 0 0.45em;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n  background-color: #73859f;\n}\n\n.my-video-dimensions.video-js .vjs-load-progress div {\n  background: #73859f;\n}\n\n.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control,\n.video-js .vjs-volume-panel:active .vjs-volume-control,\n.video-js .vjs-volume-panel:focus .vjs-volume-control,\n.video-js .vjs-volume-panel .vjs-volume-control:active,\n.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control,\n.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active {\n  visibility: visible;\n  opacity: 1;\n  position: relative;\n  transition: none;\n}\n\n.vjs-volume-bar.vjs-slider-vertical {\n  width: 0.3em;\n  height: 8em;\n  margin: 1.35em auto;\n}\n\n@media only screen and (max-width: 600px) {\n  .my-video-dimensions.video-js .vjs-tech {\n    object-fit: contain;\n  }\n}\n\n@keyframes backgroundSlide {\n  0% {\n    background-position: 100% 0%;\n  }\n\n  100% {\n    background-position: 0% 0%;\n  }\n}\n\n@-webkit-keyframes backgroundSlide {\n  0% {\n    background-position: 100% 0%;\n  }\n\n  100% {\n    background-position: 0% 0%;\n  }\n}\n\n@-moz-keyframes backgroundSlide {\n  0% {\n    background-position: 100% 0%;\n  }\n\n  100% {\n    background-position: 0% 0%;\n  }\n}\n\n@-o-keyframes backgroundSlide {\n  0% {\n    background-position: 100% 0%;\n  }\n\n  100% {\n    background-position: 0% 0%;\n  }\n}\n\n.next-videos-slider {\n  display: flex;\n  overflow: hidden;\n  padding: 20px;\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 68.4%;\n  /* left: ; */\n  background: transparent;\n  z-index: 1;\n}\n\n.video-thumbnail {\n  width: 212px;\n  height: 119px;\n  object-fit: cover;\n  pointer-events: auto;\n  background: transparent;\n  z-index: 1;\n  border-radius: 8px;\n}\n\n.video-title {\n  text-align: center;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.tog {\n  pointer-events: auto;\n  position: absolute;\n  color: white;\n  top: 80.4%;\n  left: 48.6%;\n  background: transparent;\n  z-index: 1;\n}\n\n/* Theme-Video-Player */\n.theme-video-dimensions.vjs-fluid:not(.vjs-audio-only-mode) {\n  padding-top: 46.25%;\n}\n\n.theme-video-dimensions.video-js .vjs-tech {\n  object-fit: cover;\n}\n\n.swiper-wrapper-container {\n  position: relative;\n  width: 100%;\n  top: 57%;\n}\n\n.playerClose {\n  font-size: 25px !important;\n  color: white;\n  position: absolute;\n  z-index: 1;\n}\n\n.close-button {\n  position: absolute;\n  top: -38px;\n  right: 21px;\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  font-size: 16px;\n  cursor: pointer;\n  z-index: 10;\n}\n\n.vjs-icon-captions:before,\n.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before,\n.video-js .vjs-captions-button .vjs-icon-placeholder:before {\n  content: \"\\f10c\";\n}\n\n.my-video-dimensions.video-js.vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {\n  vertical-align: middle;\n  display: none;\n  margin-bottom: -0.1em;\n}\n\n.vjs-button>.vjs-icon-placeholder:before {\n  font-size: 1.8em;\n  /* line-height: 1.67; */\n}\n\n.my-video-dimensions.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {\n  vertical-align: middle;\n  display: none;\n  margin-bottom: -0.1em;\n}\n\n.my-video-dimensions .vjs-button>.vjs-icon-placeholder:before {\n  position: relative;\n  font-size: 25px;\n}\n\n.my-video-dimensions .vjs-remaining-time-display {\n  font-size: 15px;\n}\n\n.my-video-dimensions .vjs-playback-rate .vjs-playback-rate-value {\n  top: 17px !important;\n}\n\n.play-skip-button-center {\n  inset: 0;\n  margin: auto auto;\n  height: 20px;\n  z-index: 1;\n  display: flex;\n}\n\n.custom-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.vjs-marker {\n  position: absolute;\n  top: 30px;\n  width: 4px;\n  height: 0.4em;\n  background-color: #fbeb2b;\n}\n\n/* #vjs_video_3_ima-countdown-div,  */\n.hideTitle {\n  display: none !important;\n}\n\n.my-video-dimensions.video-js .vjs-progress-holder .vjs-progress-end {\n  width: 100% !important;\n}\n\n.vjs-live-display-playout {\n  font-size: 18px;\n}\n\n.vjs-live-display {\n  display: none !important;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.live_dot {\n  animation: blink 1s infinite;\n  font-size: 30px;\n  color: red;\n}\n\n.watermark-link:hover {\n  opacity: 1 !important;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.vjs-icon-cog:before {\n  content: \"\" !important;\n}\n\n.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  max-height: 19em;\n  font-size: 8px;\n}\n\n.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content {\n  max-height: 19em;\n  font-size: 8px;\n}\n\n.vjs-menu-content {\n  bottom: 0;\n  width: 50%;\n  z-index: 2;\n  font-size: 8px;\n  right: 35px;\n}\n\n.vjs-playback-rate .vjs-playback-rate-value {\n  font-size: 13px;\n  line-height: 3 !important;\n}\n\n.my-video-dimensions.video-js .vjs-progress-holder .vjs-play-progress {\n  width: 100% !important;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
